module.exports = __webpack_public_path__ + "static/media/stop-11.63c4d64d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-11.svg
// module id = 1356
// module chunks = 0